export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const TID = {
  // Header
  header: 'site-header',
  navLogo: 'nav-logo',
  navLink: (key) => `nav-link-${key}`,
  cartButton: 'header-cart-button',
  cartBadge: 'header-cart-badge',

  // Hero
  heroSection: 'hero-section',
  heroShopBtn: 'hero-shop-now-btn',
  heroStoryBtn: 'hero-our-story-btn',

  // Sections
  soapsSection: 'soaps-section',
  chocolatesSection: 'chocolates-section',
  aboutSection: 'about-section',
  contactSection: 'contact-section',
  footer: 'site-footer',

  // Product
  productCard: (id) => `product-card-${id}`,
  addToCartBtn: (id) => `add-to-cart-${id}`,

  // Cart drawer
  cartDrawer: 'cart-drawer',
  cartItem: (id) => `cart-item-${id}`,
  cartItemIncrement: (id) => `cart-item-inc-${id}`,
  cartItemDecrement: (id) => `cart-item-dec-${id}`,
  cartItemRemove: (id) => `cart-item-remove-${id}`,
  cartSubtotal: 'cart-subtotal',
  cartCheckoutBtn: 'cart-checkout-btn',
  cartEmpty: 'cart-empty-state',

  // Checkout
  checkoutDialog: 'checkout-dialog',
  checkoutStepShipping: 'checkout-step-shipping',
  checkoutStepPayment: 'checkout-step-payment',
  checkoutStepReview: 'checkout-step-review',
  checkoutStepConfirm: 'checkout-step-confirmation',
  checkoutInput: (name) => `checkout-input-${name}`,
  checkoutPayMethod: (method) => `checkout-pay-${method}`,
  checkoutContinueBtn: 'checkout-continue-btn',
  checkoutContinueToReviewBtn: 'checkout-continue-review-btn',
  checkoutPlaceOrderBtn: 'checkout-place-order-btn',
  checkoutCloseBtn: 'checkout-close-btn',
  checkoutOrderId: 'checkout-order-id',

  // Contact
  contactForm: 'contact-form',
  contactInput: (name) => `contact-input-${name}`,
  contactSubmit: 'contact-submit-btn',

  // Newsletter
  newsletterInput: 'newsletter-input',
  newsletterSubmit: 'newsletter-submit-btn',
};
